"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var ChangeOrderSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M12,4 L12,12.2928932 L13.1649964,11.1408249 C13.330901,10.9767614 13.5856946,10.9575593 13.7724118,11.082343 L13.8507514,11.1476371 C14.0391995,11.3415487 14.0375633,11.6506837 13.8470732,11.8425896 L11.5,14.2071068 L9.16286816,11.8771355 C8.96951134,11.6843711 8.96871994,11.3714546 9.16109925,11.1777146 C9.35364368,10.9838083 9.66668228,10.9819334 9.86153563,11.1735193 L11,12.2928932 L11,4 L12,4 Z M5.5,3.79289322 L7.84707317,6.15741038 C8.01375206,6.32532806 8.03583962,6.58299928 7.91251163,6.77469896 L7.85075139,6.85236288 C7.68411237,7.02089465 7.42922699,7.04326703 7.24108869,6.92061568 L7.16499642,6.85917513 L6,5.70710678 L6,14 L5,14 L5,5.70710678 L3.86153563,6.8264807 C3.66668228,7.01806663 3.35364368,7.01619168 3.16109925,6.82228541 C2.99009542,6.6500721 2.9717203,6.38369462 3.10554877,6.19124111 L3.16286816,6.12286453 L5.5,3.79289322 Z" })));
};
ChangeOrderSmall.displayName = 'ChangeOrderSmall';
exports.default = ChangeOrderSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ChangeOrderSmall.js.map